<template>
	<div class="modal_mask">
		<div class="find-modal">
			<span class="iconfont icon-no close_button" @click="$emit('close')"></span>
			<div class="title">修改密码</div>
			<div class="find-modal-inner">
				<el-form :model="form" :rules="formRules" ref="form" class="login-form" label-width="0"
					@keyup.enter.native="submit" autocomplete="off">
					<el-form-item label="" prop="new_password">
						<el-input type="text" placeholder="请输入密码" v-model="form.new_password"></el-input>
					</el-form-item>
					<el-form-item label="" prop="repassword">
						<el-input type="text" placeholder="请再次确认密码" v-model="form.repassword"></el-input>
					</el-form-item>
					<el-form-item class="submit-btns">
						<el-button class="submit-btn" @click="$emit('close')">取消</el-button>
						<el-button class="submit-btn" type="primary" @click="submit" :disabled="loginStatus" :loading="loginStatus">
							确定
						</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'editPassword',
	props: {
		passwordSmsCode: {
			default: '',
			type: String,
		},
	},
	data () {
		var validatePass = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入新密码'))
			} else {
				var reg = /^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*)(?=.*[\.,#?!@$%^&*-].*)[0-9A-Za-z\.,#?!@$%^&*-]{12,32}$/
				if (!reg.test(this.form.new_password)) {
					callback(new Error('密码由12-32位数字、大/小写字母、常用特殊字符组成'))
				}
				callback()
			}
		}
		var validateConfimPassword = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请再次输入新密码'))
			} else if (value !== this.form.new_password) {
				callback(new Error('两次输入密码不一致!'))
			} else {
				callback()
			}
		}
		return {
			form: {
				new_password: '', // 密码
				repassword: '', // 确认密码
			},
			loginStatus: false, // 点击按钮请求是， 需禁用
			formRules: {
				new_password: [{ validator: validatePass, trigger: 'blur' }],
				repassword: [{ validator: validateConfimPassword, trigger: 'blur' }],
			},
		}
	},
	computed: {
		loginInfo () {
			return this.$store.getters.loginInfo
		},
	},
	methods: {
		submit () {
			this.loginStatus = true
			this.$refs['form'].validate(valid => {
				if (valid) {
					let { new_password, repassword } = this.form
					var data = {
						new_password,
						repassword,
					}
					loginSdk.requestAction("token_user").then(res => {
						if (res.code == 0) {
							let user_id = res.data.id;
							data.user_id = user_id;
							loginSdk.requestAction("edit_pwd", data).then(res => {
								if (res.code == 0) {
									Vue.prototype.$message.success(res.msg);
									window.location.reload();
								} else {
									Vue.prototype.$message.error(res.msg);
									this.loginStatus = false
								}
							})
						}else {
							this.loginStatus = false
						}
					})
				} else {
					this.loginStatus = false
				}
			})
		},
	},
}
</script>

<style lang="scss" scoped>
.modal_mask {
	position: fixed;
	z-index: 998;
	top: 0;
	left: 0;
	height: 100%;
	width: 100%;
	background: rgba(0, 0, 0, 0.5);
}

.find-modal {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	background: #ffffff;
	box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
	border-radius: 8px;
	width: 400px;
	min-height: 300px;
	box-sizing: border-box;

	.title {
		height: 70px;
		line-height: 70px;
		padding: 0 24px;
		color: #3b3946;
		font-size: 16px;
		font-weight: bold;
		border-bottom: 2px solid #f7f6f9;
	}

	.close_button {
		position: absolute;
		top: 22px;
		right: 24px;
		font-size: 26px;
		color: #999;
	}

	.find-modal-inner {
		width: 100%;
		padding: 24px 24px 32px;

		.success-icon {
			width: 52px;
			height: 52px;
			display: block;
			margin: 31px auto 0;
		}

		p {
			font-size: 22px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #333;
			line-height: 30px;
			text-align: center;
			margin: 34px auto 22px;
		}

		::v-deep .el-form-item {
			margin-bottom: 24px;
		}

		.submit-btns {
			text-align: right;
			margin: 0;

			.submit-btn {
				width: 88px;
				height: 40px;
			}
		}

		.pass-input {
			::v-deep .el-input__inner {
				border-radius: 4px 0 0 4px;
			}
		}

		::v-deep .send-btn.is-disabled {
			padding: 12px 0;
		}
	}
}
</style>
